import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { setupStore } from './redux/store';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import App from './App';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import posthog from 'posthog-js';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_PROJECT_TOKEN as string, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
});
posthog.register({
  source: 'web', // separate from Telegram bot
});

const store = setupStore();

const muiTheme = createTheme({
  /* custom theme */
  palette: {
    primary: {
      // main: '#00CABA',
      main: '#3653B7',
    },
    secondary: {
      main: '#3653B7',
    },
    info: {
      main: '#7030a0',
    },
    text: {
      primary: '#35435E',
      secondary: '#FFFFFF',
    },
    error: {
      main: '#f32a2a',
      dark: '#f32a2a',
    },
  },
  typography: {
    subtitle1: {
      fontWeight: 700,
      fontSize: '15px',
      textTransform: 'uppercase',
    },
  },
});

render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={muiTheme}>
                <App />
              </ThemeProvider>
            </StyledEngineProvider>
          </QueryParamProvider>
        </BrowserRouter>
      </Provider>
    </PostHogErrorBoundary>
  </PostHogProvider>,
  document.getElementById('root')
);
